/**
 * © [2024] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const HANDLE_ERROR_MESSAGE_RR = 'HANDLE_ERROR_MESSAGE_RR';
export const REMINDER_RECIPE_SCREEN_TAB_DATA =
  'REMINDER_RECIPE_SCREEN_TAB_DATA';
export const SAVE_OR_UPDATE_RR = 'SAVE_OR_UPDATE_RR';
export const GET_REMINDER_RECIPIENT_LIST = 'GET_REMINDER_RECIPIENT_LIST';
export const GET_REMINDER_USER_LIST = 'GET_REMINDER_USER_LIST';
